import { render, staticRenderFns } from "./login-old.vue?vue&type=template&id=341cff29&"
import script from "./login-old.vue?vue&type=script&lang=js&"
export * from "./login-old.vue?vue&type=script&lang=js&"
import style0 from "./login-old.vue?vue&type=style&index=0&id=341cff29&prod&lang=less&"
import style1 from "./login-old.vue?vue&type=style&index=1&id=341cff29&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports